import React from "react";
import { observer, inject } from "mobx-react";
import * as Icon from "react-feather";
import * as C from "vonnegut.components";
import GroupEdit from "./group-edit.js";
import { values } from "mobx";
import { createFilter } from "react-search-input";

import * as M from "@material-ui/core";

const GroupContainer = props => {
  const { $group, $router, $validation, $user } = props.store;

  React.useEffect(() => {
    $group.change("filterSearch", "");
  }, [$group]);

  const cols = [
    { label: "ID", key: "_key", width: "15%" },
    { label: "CreatedOn", key: "createdOn", width: "12%", type: "date" },
    { label: "Naam", key: "name", width: "25%" },
    //{ label: "R", key: "totalRespondentCount", width: "2%" },
    { label: "CreatedByEmail", key: "createdByEmail", width: "20%" },
    {
      type: "action",
      icon: <Icon.Edit2 />,
      className: "bg-transparent",
      onClick: (e, row) => $router.push("/group/edit/" + row._key)
    }
  ];

  return (
    <React.Fragment>
      <header className="flex justify-between">
        <h2>Groepen/scholen</h2>
        <M.Button onClick={() => $router.push("/group/new")}>Nieuwe groep</M.Button>
      </header>

      <div className="p-8">
        <M.TextField
          fullWidth
          placeholder="ID, Naam, begeleider (ID), ... "
          onChange={e => $group.change("filterSearch", e.target.value)}
          name="filter-search"
          InputProps={{
            startAdornment: (
              <M.InputAdornment position="start">
                <Icon.Search />
              </M.InputAdornment>
            )
          }}
        />

        <div className="mt-4 mb-4">
          <b>{$group.list.size > 0 && $group.list.size}</b>
          &nbsp;scholen/groepen gevonden
        </div>

        <C.List cols={cols} className="zebra" sortKey="createdOn" sortDirection="desc">
          {values($group.list)
            .filter(createFilter($group.filterSearch, ["name", "createdByEmail", "_key"]))
            .map(group => (
              <C.ListRow key={group._key} row={group} />
            ))}
        </C.List>

        {$group.selected && ($router.mode === "edit" || $router.mode === "new") && (
          <M.Dialog
            open={Boolean($group.selected)}
            onClose={() => $group.detach($group.selected)}
            fullWidth
            maxWidth="sm"
          >
            <M.DialogTitle>
              {$group.selected._key === "new" ? "Groep/school toevoegen" : $group.selected.name}
            </M.DialogTitle>
            <M.DialogContent>
              <GroupEdit {...props} />
            </M.DialogContent>
            <M.DialogActions>
              {$user.sessionUser.isVerifiedCreator && (
                <M.Button
                  variant="outlined"
                  startIcon={<Icon.Trash size={18} color="#444" />}
                  onClick={e => $group.change("confirmDelete", true)}
                >
                  Verwijderen
                </M.Button>
              )}
              <M.Button
                variant="outlined"
                onClick={() => {
                  $router.push("/group");
                  $group.detach($group.selected);
                }}
              >
                Annuleren
              </M.Button>
              <M.Button
                onClick={async () => {
                  const validations = $validation.validateForm("group-edit");
                  if (validations.size === 0) {
                    await $group.selected.fsSave();
                    $router.push("/group");
                    $group.load();
                    $group.detach($group.selected);
                  }
                }}
              >
                {$group.selected._key === "new" ? "Voeg toe" : "Bewaren"}
              </M.Button>
            </M.DialogActions>
          </M.Dialog>
        )}

        <M.Dialog open={$group.confirmDelete} onClose={() => $group.change("confirmDelete", false)}>
          <M.DialogTitle>Let op!</M.DialogTitle>
          <M.DialogContent>
            Deze groep wordt verwijderd. De gekoppelde antwoorden en gebruikers blijven bestaan maar
            verliezen de koppeling met deze groep.
          </M.DialogContent>
          <M.DialogActions>
            <M.Button variant="outlined" onClick={() => $group.change("confirmDelete", false)}>
              Annuleren
            </M.Button>
            <M.Button
              onClick={async () => {
                await $group.selected.delete();
                //$group.load();
                $router.push("/group");
                $group.change("confirmDelete", false);
              }}
              className={"bg-red"}
            >
              verwijderen
            </M.Button>
          </M.DialogActions>
        </M.Dialog>
      </div>
    </React.Fragment>
  );
};

export default inject("store")(observer(GroupContainer));
